export const lifeColor = "#FF0000";
export const lifeStrongColor = "#9D0505";
